import { EnterpriseTeamIcon } from 'v5/features/core/enterprise/EnterpriseTeamIcon';
import { EnterpriseWorkspaceIcon } from 'v5/features/core/enterprise/EnterpriseWorkspaceIcon';
import { ImageUploadField } from 'v5/patterns/forms/fields/image-upload/ImageUploadField';
import { WithServices } from 'v5/platform/ts/services';
import { WithToastService } from 'v5/services/front/ToastService/ToastService';
import { WithUploadService } from 'v5/services/io/UploadService/UploadService';

export type EnterpriseIconUploadFieldProps = WithServices<
  [WithUploadService, WithToastService]
> & {
  value: string;
  onChange: (value: string) => void;
  previewName: string;
  variant: 'workspace' | 'team';
  iconColor?: string;
  disabled?: boolean;
};

/** Workspace / team icon; the empty tile previews the initials fallback. */
export function EnterpriseIconUploadField({
  services,
  value,
  onChange,
  previewName,
  variant,
  iconColor = '',
  disabled = false
}: EnterpriseIconUploadFieldProps) {
  return (
    <ImageUploadField
      services={services}
      // The form stores "no icon" as an empty string.
      value={value === '' ? null : value}
      onChange={next => onChange(next ?? '')}
      disabled={disabled}
      placeholder={
        variant === 'workspace' ? (
          <EnterpriseWorkspaceIcon
            name={previewName}
            iconUrl=""
            className="size-full rounded-none text-xl"
          />
        ) : (
          <EnterpriseTeamIcon
            name={previewName}
            iconUrl=""
            iconColor={iconColor}
            className="size-full rounded-none ring-0 [&>span]:text-xl"
          />
        )
      }
    />
  );
}
